import React from 'react';
import {BarcodeScanner} from "./_scanner.jsx";

class QrscannerComponent extends React.Component {
	constructor(props) {
		super(props);

        this.flags = props.value ?? [];
		
		this.state = { 
			flag: -1,
            flagName: 'Sélectionnez le flag à scanner',
            scan: false,
            result: false,
		};

        this.close = props.close;
	}

    selectFlag(id, nom) {
        this.setState({
            flag: id,
            flagName: nom,
            scan: true,
        });
    }

    goScan() {
        this.setState({
            result: false,
            scan: true,
        });
    }

    handleResult(result, el) {
        el.setState({
            scan: false,
        });

        let formData = new FormData();
        formData.append('action', 'scanqr');
        formData.append('flag', el.state.flag);
        formData.append('code', result.getText());

        fetch('', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new URLSearchParams(formData)
        })
        .then(response => response.json())
        .then(function(data) {
            el.setState({
                result: data,
                scan: false,
            });
            if (data.hasOwnProperty('dates')) {
                this.updateList(data.contact.id, this.state.flag, data.dates);
            }
        });
    }

    confirmScan(reponse, el) {
        let formData = new FormData();
        formData.append('action', 'scanqrconfirm');
        formData.append('flag', el.state.flag);
        formData.append('contact', el.state.result.contact.id);
        formData.append('reponse', reponse);

        fetch('', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new URLSearchParams(formData)
        })
        .then(response => response.json())
        .then(function(data) {
            el.setState({
                result: false,
                scan: true,
            });
            if (data.hasOwnProperty('dates')) {
                el.updateList(data.contact.id, el.state.flag, data.dates);
            }
        });
    }

    updateList(contact, flag, dates) {
        let value = '<div class="mb-2">';
        value += '<a data-bs-toggle="collapse" href="#dates_' + flag + '_' + contact + '"><strong>' + dates.length + ' activation' + ( dates.length > 1 ? 's' : '' ) + '</strong></a>';
        value += '<div class="collapse" id="dates_' + flag + '_' + contact + '">';
        for (let i = 0; i < dates.length; i++) {
            let date = new Date(dates[i].date);
            let day = date.getDate();
            if ( day < 10 )
                day = '0' + parseInt(day);
            let month = date.getMonth() + 1;
            if ( month < 10 )
                month = '0' + parseInt(month);
            let year = date.getFullYear();
            let hours = date.getHours();
            if ( hours < 10 )
                hours = '0' + parseInt(hours);
            let minutes = date.getMinutes();
            if ( minutes < 10 )
                minutes = '0' + parseInt(minutes);
            let seconds = date.getSeconds();
            if ( seconds < 10 )
                seconds = '0' + parseInt(seconds);
            let c = '';
            if ( dates[i].reponse !== null ) {
                c = dates[i].reponse ? ' text-success' : ' text-danger';
            }
            value += '<div class="text-nowrap' + c + '">' + day + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + dates[i].user + '</div>';
        }
        value += '</div></div>';
        document.querySelectorAll('[data-flagcontact="' + flag + ',' + contact + '"] .dates').forEach(function(el) {
            el.innerHTML = value;
        });
    }

	render() {
		return (
			<div id="qrscanner">
                <header>
                    <button onClick={this.close} type="button" className="btn-close btn-close-white" aria-label="Close"></button>
                    <h4>{ this.state.flagName }</h4>
                </header>
                <div className="content container">
                    {(() => {
                        if ( this.state.flag == -1 ) {
                            return <div className="select_flag">
                                {(() => {
                                    let btns;
                                    btns = this.flags.map( ( flag ) => {
                                        return <button key={flag.id} type="button" className="btn btn-lg btn-success" onClick={e => this.selectFlag(flag.id, flag.nom)}>{flag.nom}</button>;
                                    });
                                    return btns;
                                })()}
                            </div>;
                        } else {
                            if ( this.state.scan ) {
                                return <div className="video-container"><BarcodeScanner handleResult={(result) => this.handleResult(result, this)} /></div>;
                            } else if ( this.state.result ) {
                                return <div className={'result ' + this.state.result.type}>
                                    <div className="picto">
                                        {(() => {
                                            let picto;
                                            if ( this.state.result.type == 'success' ) {
                                                picto = 'bi-check-lg';
                                            } else if ( this.state.result.type == 'warning' ) {
                                                picto = 'bi-exclamation';
                                            } else if ( this.state.result.type == 'error' ) {
                                                picto = 'bi-x';
                                            } else if ( this.state.result.type == 'confirm' ) {
                                                picto = 'bi-question';
                                            }
                                            return <i className={'bi ' + picto}></i>;
                                        })()}
                                    </div>
                                    {(() => {
                                        let content;
                                        if ( this.state.result.hasOwnProperty('msg_alert') ) {
                                            return <div className="msg_alert">{ this.state.result.msg_alert}</div>;
                                        }
                                    })()}
                                    {(() => {
                                        if ( this.state.result.hasOwnProperty('contact') ) {
                                            return <div className="contact p-4 rounded-3">{this.state.result.contact.prenom} {this.state.result.contact.nom}</div>;
                                        }
                                    })()}
                                    {(() => {
                                        if ( this.state.result.hasOwnProperty('msg') ) {
                                            return <div className="msg" dangerouslySetInnerHTML={{__html: this.state.result.msg}} />;
                                        }
                                    })()}
                                    {(() => {
                                        if ( this.state.result.type == 'confirm' ) {
                                            return <>
                                                <div className="confirm">
                                                    <div className="row">
                                                        <div className="col">
                                                            <button type="button" className="btn btn-lg btn-success w-100" onClick={() => this.confirmScan(1, this)}>
                                                                <i className="success bi bi-check-lg"></i>
                                                                <div className="text-uppercase">Accepter</div>
                                                            </button>
                                                        </div>
                                                        <div className="col">
                                                            <button type="button" className="btn btn-lg btn-danger w-100" onClick={() => this.confirmScan(0, this)}>
                                                                <i className="success bi bi-x"></i>
                                                                <div className="text-uppercase">Refuser</div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-auto text-center">
                                                    <button type="button" className="btn btn-secondary" onClick={e => this.goScan()}>Annuler</button>
                                                </div>
                                            </>;
                                        } else {
                                            return <div className="mt-auto text-center">
                                                <button type="button" className="btn btn-secondary" onClick={e => this.goScan()}>Sanner un autre code</button>
                                            </div>;
                                        }
                                    })()}
                                </div>
                            }
                        }
                    })()}
                </div>
            </div>
        );
	}
}

export default QrscannerComponent;